import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocSelectedTypeState = atom({
  key: "ocSelectedTypeState",
  default: undefined,
  effects_UNSTABLE: [ocPersistAtom],
});
